import { useQuery } from 'react-query';

import { nomPersonne } from '../../../types/housekeepingMessaging';
import { lireLecteurs } from '../../api/useMessagesMenage';
import BottomSheet from '../../components/BottomSheet';
import EtatErreur from '../../components/EtatErreur';
import Text from '../../components/Text';
import { heureBulle } from '../../helpers/conversation';
import { t } from '../../i18n/langue';

/** Q16 : qui a lu un message — d'abord celles qui ne l'ont pas encore lu. */
export default function FeuilleLecteurs({ messageId, onFermer }: { messageId: number; onFermer: () => void }) {
    const { data, isLoading, isError, refetch } = useQuery(['hk-messaging-readers', messageId], () => lireLecteurs(messageId));

    return (
        <BottomSheet ouverte onClose={onFermer} libelle={t('messagesMenage.lecteurs.titre')} libelleFermeture={t('commun.fermer')}>
            <div className="flex flex-col gap-2">
                <Text variante="sousTitre" as="h2">
                    {t('messagesMenage.lecteurs.titre')}
                </Text>
                {isLoading && (
                    <Text variante="petit" ton="attenue">
                        {t('commun.chargement')}
                    </Text>
                )}
                {isError && <EtatErreur onReessayer={() => void refetch()} />}
                {[...(data ?? [])]
                    .sort((a, b) => Number(a.read_at !== null) - Number(b.read_at !== null))
                    .map((lecteur) => (
                        <div key={lecteur.id} className="flex items-center justify-between gap-3 rounded-xl bg-white px-3 py-2">
                            <Text as="span">{nomPersonne(lecteur)}</Text>
                            <Text variante="petit" ton={lecteur.read_at ? 'marque' : 'attenue'} as="span">
                                {lecteur.read_at
                                    ? t('messagesMenage.lecteurs.aLu', { heure: heureBulle(lecteur.read_at) })
                                    : t('messagesMenage.lecteurs.pasLu')}
                            </Text>
                        </div>
                    ))}
            </div>
        </BottomSheet>
    );
}
